/*  Hr Routes */
export default [
  {
    path: '/jobs/hr/delegations/',
    name: 'hr-delegations',
    meta: {
      name: 'main.routes.hr-delegations',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/hr/MyDelegations.vue')
  },
  // Delegate
  // ---------------
  {
    path: '/jobs/hr/delegate/:id',
    name: 'hr-delegate-user',
    meta: {
      name: 'main.routes.hr-delegate-user',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/hr/DelegateUser.vue')
  },
  {
    path: '/jobs/hr/delegate-external/:id',
    name: 'hr-delegate-external-user',
    meta: {
      name: 'main.routes.hr-delegate-external-user',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/hr/DelegateExternalUser.vue')
  },
  {
    path: '/jobs/hr/delegate/offer/:id',
    name: 'hr-delegate-offer',
    meta: {
      name: 'main.routes.hr-delegate-offer',
      auth: true,
      layout: 'jobs'
    },
    component: () => import('@/views/jobs/hr/DelegateOffer.vue')
  },
  // ---------------
]
